import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { updateProponent, getProponentById } from '../../api/proponent';
import './edit.css';

const EditProponentComponent: React.FC = () => {
  const { id } = useParams<{ id }>();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchProponent() {
      setLoading(true);
      try {
        const proponentData = await getProponentById(id);
        setLoading(false);
        form.setFieldsValue(proponentData.response);
      } catch (error) {
        setLoading(false);
        console.error('Error fetching proponent:', error);
      }
    }

    fetchProponent();
  }, [id, form]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await updateProponent(id, { ...values, name: values.display_name });
      message.success({
        content: 'Proponent updated successfully',
        duration: 4,
        style: { textAlign: 'right' },
      });
      navigate('/proponents');
    } catch (error: any) {
      console.error('Error updating proponent:', error);
      message.error({
        content: error.message,
        duration: 4,
        style: { textAlign: 'right' },
      });
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo);
  };

  return (
    <div className="update-proponent-container">
      <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />} fullscreen />
      <div className="form-container">
        <h1>Update Proponent</h1>
        <Form
          form={form}
          name="updateProponentForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item
            label="Name"
            name="display_name"
            rules={[{ required: true, message: 'Please input the name of the proponent!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default EditProponentComponent;
